import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  TableCell,
  TableRow,
} from "@mui/material";
import { Colors } from "../../constants/Colors";
import Card from "../../components/Card";
import CustomTable from "../../components/Table";
import CustomButton from "../../components/Button";
import CustomInput from "../../components/Input";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { apiRequest } from "../../services/api-request";
import Pagination from "../../components/Pagination";
import { downloadFile } from "../../utilities/exportToCsv";

const dashboardHeader = [
  {
    id: 1,
    title: "S No.",
  },
  {
    id: 2,
    title: "Date",
  },
  {
    id: 3,
    title: "Buyer ID",
  },
  {
    id: 4,
    title: "Buyer Name",
  },
  {
    id: 5,
    title: "Seller ID",
  },
  {
    id: 6,
    title: "Seller Name",
  },
  {
    id: 7,
    title: "Seller Details",
  },
  {
    id: 8,
    title: "Animal Details",
  },
  {
    id: 9,
    title: "Transaction ID",
  },
  {
    id: 10,
    title: "Amount",
  },
  {
    id: 11,
    title: "Status",
  },
];

const States = () => {
  const [paymentList, setPaymentList] = useState({
    result: [],
    totalCount: "",
    loader: false,
  });

  const limit = 10;
  const [skip, setSkip] = useState(0);

  const [paymentListCSV, setPaymentListCSV] = useState({
    data: [],
  });

  useEffect(() => {
    getLists({ skip, searchText: "" });
  }, [skip]);

  const getLists = ({ skip, searchText }) => {
    setPaymentList({ loader: true });
    const payload = {
      skip: skip,
      limit: limit,
      ...(searchText && {
        searchText: searchText,
      }),
    };

    let search = searchText ? searchText : ''
    apiRequest({
      url: "mithun/get-ccavenuepayment-lists?search="+search,
      method: "GET",
      data: payload,
    })
      .then((res) => {
        setPaymentList({
          loader: false,
          totalCount: res.total_count ? res.total_count : res.data.length,
          result: res.data,
        });
      })
      .catch((err) => {
        setPaymentList({ loader: false });
      });
  };

  const handlePageChange = (pageNumber) => {
    const newSkip = (pageNumber - 1) * limit;
    setSkip(newSkip);
  };

  const TableDataUi = () => {
    return paymentList?.result?.map((row, index) => (
      <TableRow
        key={row.user_id}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {index + 1}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.date}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.buyer_id}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.buyer_name}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.seller_id}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.seller_name}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.seller_details}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.animal_details}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.transaction_id}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.amount}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.status}
          </Typography>
        </TableCell>
      </TableRow>
    ));
  };

  const handleSearchTextChange = (e) => {
    const searchText = e.target.value;
    getLists({ searchText });
  };

  // useEffect(() => {
  //   let headers = ["S No., Date, Buyer ID, Buyer Name, Seller ID, Seller Name, Seller Details, Animal Details, Transaction ID, Amount, Status"];

  //   let paymentCsv;
  //   if (Array.isArray(paymentListCSV.data) && paymentListCSV.data.length > 0) {
  //     paymentCsv = paymentListCSV.data?.reduce((acc, rec, index) => {
  //       acc.push([index+1, rec.date, rec.buyer_id, rec.buyer_name, rec.seller_id, rec.seller_name, rec.seller_details, rec.animal_details, rec.transaction_id, rec.amount, rec.status].join(","));
  //       return acc;
  //     }, []);

  //     downloadFile({
  //       data: [...headers, ...paymentCsv].join("\n"),
  //       fileName: "Ccavenuepayment List.csv",
  //       fileType: "text/csv",
  //     });
  //   }
  // }, [paymentListCSV]);

  useEffect(() => {
    const headers = [
      "S No.", "Date", "Buyer ID", "Buyer Name", "Seller ID", "Seller Name",
      "Seller Details", "Animal Details", "Transaction ID", "Amount", "Status"
    ];

    const escapeField = (field) => {
      if (typeof field === "string") {
        // Escape existing quotes and wrap the field in quotes
        return `"${field.replace(/"/g, '""')}"`;
      }
      return `"${field}"`; // wrap non-string fields too
    };

    if (Array.isArray(paymentListCSV.data) && paymentListCSV.data.length > 0) {
      const paymentCsv = paymentListCSV.data.reduce((acc, rec, index) => {
        const row = [
          index + 1,
          rec.date,
          rec.buyer_id,
          rec.buyer_name,
          rec.seller_id,
          rec.seller_name,
          rec.seller_details,
          rec.animal_details,
          rec.transaction_id,
          rec.amount,
          rec.status
        ].map(escapeField).join(",");

        acc.push(row);
        return acc;
      }, []);

      const csvContent = [headers.map(escapeField).join(","), ...paymentCsv].join("\n");

      downloadFile({
        data: csvContent,
        fileName: "Ccavenuepayment_List.csv",
        fileType: "text/csv",
      });
    }
  }, [paymentListCSV]);


  const exportToCsv = () => {
    let payload = {
      skip: skip,
      limit: 100000000,
    };
    apiRequest({
      url: "mithun/get-ccavenuepayment-lists",
      data: payload,
      method: "GET",
    })
      .then((res) => {
        setPaymentListCSV({
          data: res?.data,
        });
      })
      .catch((err) => {
        alert(err);
      });
  };

  return (
    <Box>
      <Grid container justifyContent={"end"}>
        <CustomButton
          title={"Export List"}
          handleButtonClick={() => exportToCsv()}
          backgroundColor={Colors.headerColor}
          textColor={Colors.white}
          textFontSize={14}
          padding={"5px 10px"}
        />
      </Grid>
      <Grid
        container
        alignItems={"center"}
        justifyContent={"space-between"}
        mt={2}
      >
        <Grid item>
          <Typography
            fontFamily={"Poppins-Medium"}
            fontSize={20}
            color={Colors.textColor}
          >
            Total Orders
          </Typography>
          <Typography
            fontFamily={"Poppins-Regular"}
            fontSize={13}
            color={Colors.textColor}
          >
            ccavenuepayments
          </Typography>
        </Grid>
      </Grid>

      <Box mt={2}>
        <Card>
          {/*<Grid
            container
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Grid item md={3}>
              <CustomInput
                placeholder={"Search"}
                onChange={(e) => handleSearchTextChange(e)}
                leftIcon={
                  <SearchOutlinedIcon style={{ color: Colors.textColor }} />
                }
              />
            </Grid>
          </Grid>*/}
          <Box mt={2}>
            <CustomTable
              headerData={dashboardHeader}
              tableData={paymentList.result}
            >
              <TableDataUi />
            </CustomTable>
            <Box mt={2} display={"flex"} justifyContent={"right"}>
              {paymentList.totalCount > 10 && (
                <Pagination
                  totalCount={paymentList.totalCount}
                  skip={skip}
                  limit={limit}
                  onPageChange={handlePageChange}
                />
              )}
            </Box>
          </Box>
        </Card>
      </Box>
    </Box>
  );
};

export default States;
